import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { mutations } from '@/modules/FacturesFournisseurs/store/mutations';
import { actions } from '@/modules/FacturesFournisseurs/store/actions';
import { getters } from '@/modules/FacturesFournisseurs/store/getters';
import { FactureFournisseurState, state } from '@/modules/FacturesFournisseurs/store/state';

const module: Module<FactureFournisseurState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { FactureFournisseurState };

